<template lang="pug">
  validation-observer(ref="form")
    form(@submit.prevent="onSubmit" :class="b()")
      .columns.is-multiline
        .column.is-12
          //- label.label Dirección
          //- v-text-field(
          //-   v-validate="'required'"
          //-   v-model="data.address.line1"
          //-   :error-messages="errors.first('dirección')"
          //-   name="dirección"
          //- )
        .column.is-12-tablet.is-6-desktop(
          v-for="division, idx in politicalDivisions"
          v-if="idx > 0"
        )
          validation-provider(:name="division.name" rules="required" v-slot="{ errors }")
            label.label {{ division.name }}
            location-select(
              :value="$addressInput.getValue(idx)"
              :error-messages="errors"
              :name="division.name"
              :disabled="$addressInput.isDisabled(idx)"
              :parent-id="$addressInput.getParentId(idx)"
              @input="value => $addressInput.onInput(value, idx)"
            )
</template>

<script>
  import last from 'lodash/last';
  import omit from 'lodash/omit';
  import formMixin from '@/mixins/form-mixin';
  import addressInputMixin from '@/mixins/address-input-mixin';

  const DEFAULT_VALUES = {
    address: {
      line1: 'Sin dirección',
      _locationIds: ['1', '15', '153'],
    },
  };

  export default {
    name: 'property-address-form',

    mixins: [
      formMixin({
        parseSubmit(data) {
          return {
            address: {
              ...omit(data.address, ['location', 'line2', 'line3']),
              locationId: last(data.address._locationIds)
            },
          };
        },
      }),
      addressInputMixin(),
    ],

    props: {
      product: { type: String },
      populatedData: { type: Object },
    },

    data() {
      return {
        data: {
          ...DEFAULT_VALUES,
        },
      };
    },
  };
</script>

<style lang="sass" scoped>
  .property-address-form
    .column
      padding-bottom: 0
      padding-top: 0

    .label::first-letter
      text-transform: uppercase
</style>